export default __webpack_public_path__ + "static/media/para-1.807f5818.png";